// ============================================================================
// ROOM COLOR SWATCHES
// Preset colors selectable for a room, rendered on the studio calendar.
// Keep in sync with backend/src/routes/rooms.ts ALLOWED_ROOM_COLORS.
// ============================================================================

export interface RoomColorSwatch {
  label: string;
  value: string;
}

export const ROOM_COLOR_SWATCHES: RoomColorSwatch[] = [
  { label: 'Red', value: '#ef4444' },
  { label: 'Orange', value: '#f97316' },
  { label: 'Amber', value: '#f59e0b' },
  { label: 'Green', value: '#22c55e' },
  { label: 'Teal', value: '#14b8a6' },
  { label: 'Blue', value: '#3b82f6' },
  { label: 'Indigo', value: '#6366f1' },
  { label: 'Purple', value: '#a855f7' },
  { label: 'Pink', value: '#ec4899' },
  { label: 'Slate', value: '#64748b' },
];

export const DEFAULT_ROOM_COLOR = ROOM_COLOR_SWATCHES[0].value;
